export default ($api) => ({
  nghienCuuDeXuatDauTu: (data) => {
    return $api.get(`nghien-cuu-de-xuat-dau-tu-page`, { params: data })
  }
})
